const lang = {
  en: {
    search: "Search",
    gptSearchPlaceholder: "Search for movies",
  },
  hindi: {
    search: "खोज",
    gptSearchPlaceholder: "फिल्में खोजें",
  },
  spanish: {
    search: "Buscar",
    gptSearchPlaceholder: "Buscar películas",
  },
};

export default lang;
